import React from "react";

const ShareIcon = () => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7367 0.00129842C15.1295 0.00129842 13.826 1.24138 13.826 2.77038C13.826 3.03593 13.8676 3.29173 13.9406 3.5352L5.43103 6.92822C4.92806 6.09912 3.98831 5.53946 2.9107 5.53946C1.3035 5.53946 0 6.77954 0 8.30854C0 9.83754 1.3035 11.0776 2.9107 11.0776C3.75286 11.0776 4.50971 10.7355 5.04135 10.1907L10.5242 13.9395C10.31 14.3252 10.1871 14.7641 10.1871 15.2303C10.1871 16.7599 11.4906 18 13.0978 18C14.705 18 16.0085 16.7599 16.0085 15.2303C16.0085 13.7013 14.705 12.4618 13.0978 12.4618C12.2427 12.4618 11.4763 12.815 10.9433 13.3734L5.46788 9.63043C5.6931 9.23763 5.8214 8.78704 5.8214 8.30789C5.8214 8.05079 5.78182 7.80277 5.71289 7.56579L14.2286 4.17018C14.7344 4.98824 15.6666 5.53881 16.7367 5.53881C18.3439 5.53881 19.6474 4.29873 19.6474 2.76908C19.6474 1.24008 18.3439 0 16.7367 0V0.00129842ZM13.0985 13.1546C14.3024 13.1546 15.2817 14.0863 15.2817 15.2309C15.2817 16.3756 14.3024 17.3079 13.0985 17.3079C11.8946 17.3079 10.9153 16.3762 10.9153 15.2309C10.9153 14.0856 11.8946 13.1546 13.0985 13.1546ZM2.91138 10.3855C1.70752 10.3855 0.728187 9.45383 0.728187 8.30854C0.728187 7.16325 1.70752 6.23157 2.91138 6.23157C4.11524 6.23157 5.09458 7.16325 5.09458 8.30854C5.09458 9.45383 4.11524 10.3855 2.91138 10.3855ZM16.7367 4.84735C15.5328 4.84735 14.5535 3.91567 14.5535 2.77038C14.5535 1.62509 15.5328 0.693406 16.7367 0.693406C17.9406 0.693406 18.9199 1.62509 18.9199 2.77038C18.9199 3.91567 17.9406 4.84735 16.7367 4.84735Z"
        fill="black"
      />
    </svg>
  );
};

export default ShareIcon;
